import React, { useState } from "react";
import posthog from "posthog-js";
import { apiUrl, urls } from "../config.js";
import { api } from "../../../helpers/api.js";

let identifiedUserId = null;

function identifyUser(user) {
  if (
    !user?.id ||
    !process.env.REACT_APP_POSTHOG_PROJECT_TOKEN ||
    !process.env.REACT_APP_POSTHOG_HOST
  ) {
    return;
  }

  const userId = String(user.id);

  if (identifiedUserId && identifiedUserId !== userId) {
    posthog.reset();
  }

  if (identifiedUserId === userId) {
    return;
  }

  posthog.identify(userId, {
    ...(typeof user.email === "string" ? { email: user.email } : {}),
    ...(typeof user.isAdmin === "boolean" ? { is_admin: user.isAdmin } : {}),
  });
  identifiedUserId = userId;
}

export default function useLoggedUser() {
  const [user, setUser] = useState(null);

  React.useEffect(() => {
    async function checkAuthentication() {
      const user = await api(`${apiUrl}${urls.getAuthenticatedUser}`, {
        noRedirect: true,
        noErrorOnFail: true,
      });

      if (user.error) {
        return;
      }

      identifyUser(user);
      setUser(user);
    }

    checkAuthentication();
  }, []);

  const doLogout = async () => {
    const impersonated = window.localStorage.getItem("impersonate") ?? null;
    if (impersonated) {
      posthog.reset();
      identifiedUserId = null;
      window.localStorage.removeItem("impersonate");
      window.location.href = "/admin";
    } else {
      await api(`${apiUrl}${urls.logout}`, {
        credentials: "include",
      });

      posthog.reset();
      identifiedUserId = null;
      setUser(null);
      window.location.href = "/";
    }
  };

  return {
    user,
    doLogout,
  };
}
